import { action } from 'typesafe-actions';
import { ResponseActionTypes } from 'types';

export const fetchResponseAttachments = (request?: any) =>
  action(ResponseActionTypes.FETCH_RESPONSE_ATTACHMENTS_START, request);

export const fetchResponseAttachmentsSuccess = (data: any) =>
  action(ResponseActionTypes.FETCH_RESPONSE_ATTACHMENTS_SUCCESS, data);

export const fetchResponseAttachmentsFailure = (error: any) =>
  action(ResponseActionTypes.FETCH_RESPONSE_ATTACHMENTS_FAILURE, error);

export const getResponseAttachmentDownloadLink = (request?: any) =>
  action(
    ResponseActionTypes.GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_START,
    request
  );

export const getResponseAttachmentDownloadLinkSuccess = (data: any) =>
  action(
    ResponseActionTypes.GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_SUCCESS,
    data
  );

export const getResponseAttachmentDownloadLinkFailure = (error: any) =>
  action(
    ResponseActionTypes.GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_FAILURE,
    error
  );

export const getResponseAttachmentsDownloadAll = (request?: any) =>
  action(
    ResponseActionTypes.GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_START,
    request
  );

export const getResponseAttachmentsDownloadAllSuccess = (data: any) =>
  action(
    ResponseActionTypes.GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_SUCCESS,
    data
  );

export const getResponseAttachmentsDownloadAllFailure = (error: any) =>
  action(
    ResponseActionTypes.GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_FAILURE,
    error
  );
